// Free Gift Cart Reconciliation
// Ensures that when the free gift promo is enabled after a cart already exists,
// qualifying main items receive their corresponding free gift in the cart.

(function () {
  var CONFIG_SELECTOR = '.js-free-gift-config';
  var PRODUCT_SELECTOR = '.js-free-gift-product';
  var VARIANT_SELECTOR = '.js-free-gift-variant';
  var HAS_FREE_GIFT_FLAG = '_Has Free Gift';
  var FREE_GIFT_FLAG = '_Free Gift';
  var TIMESTAMP_PROP = '_timestamp';
  var PARENT_LINE_KEY_PROP = '_free_gift_parent_line_key';
  var RUN_LOCK_KEY = 'free_gift_reconcile_lock_v1';
  var RUN_LOCK_TIMEOUT_MS = 30000;

  function getNowMs() {
    return new Date().getTime();
  }

  function acquireRunLock() {
    try {
      if (window.__freeGiftReconcileRunning) return false;
      window.__freeGiftReconcileRunning = true;

      var existing = window.sessionStorage && window.sessionStorage.getItem(RUN_LOCK_KEY);
      if (existing) {
        var ts = parseInt(existing, 10);
        if (!isNaN(ts) && (getNowMs() - ts) < RUN_LOCK_TIMEOUT_MS) {
          return false;
        }
      }
      if (window.sessionStorage) window.sessionStorage.setItem(RUN_LOCK_KEY, String(getNowMs()));
      return true;
    } catch (e) {
      if (window.__freeGiftReconcileRunning) return false;
      window.__freeGiftReconcileRunning = true;
      return true;
    }
  }

  function releaseRunLock() {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(RUN_LOCK_KEY);
    } catch (e) {}
    window.__freeGiftReconcileRunning = false;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getConfigElements() {
    return Array.prototype.slice.call(document.querySelectorAll(CONFIG_SELECTOR));
  }

  function getMatchingGiftVariantId(scopeEl, mainVariantTitle) {
    var spans = Array.prototype.slice.call(scopeEl.querySelectorAll(VARIANT_SELECTOR));
    if (!spans.length) return null;

    if (!mainVariantTitle) {
      var firstAvailable = spans.find(function (el) {
        var available = el.getAttribute('data-variant-available');
        return available === 'true' || available === 'True' || available === '1';
      });
      return firstAvailable ? firstAvailable.getAttribute('data-variant-id') : spans[0].getAttribute('data-variant-id');
    }

    var selectedTitle = mainVariantTitle.split('/')[0].trim().toLowerCase();
    selectedTitle = selectedTitle.replace(/\(.*?\)/, '').trim();

    var queenSizes = ['twin', 'twin xl', 'full', 'queen', 'split king (order 2 to make a set)'];
    var pillowSize = queenSizes.indexOf(selectedTitle) > -1 ? 'queen' : 'king';

    function getTitle(el) {
      var t = el.getAttribute('data-variant-title') || '';
      return t.trim().toLowerCase();
    }

    // Exact match
    var exact = spans.find(function (el) {
      return getTitle(el) === selectedTitle;
    });
    if (exact) return exact.getAttribute('data-variant-id');

    try {
      var escaped = selectedTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var boundaryRegex = new RegExp('\\b' + escaped + '\\b', 'i');
      var boundary = spans.find(function (el) {
        return boundaryRegex.test(getTitle(el));
      });
      if (boundary) return boundary.getAttribute('data-variant-id');
    } catch (e) {
    }

    // Pillow-tier fallback (queen/king mapping)
    try {
      var pillowRegex = new RegExp('\\b' + pillowSize.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
      var pillow = spans.find(function (el) {
        return pillowRegex.test(getTitle(el));
      });
      if (pillow) return pillow.getAttribute('data-variant-id');
    } catch (e) {
    }

    var available = spans.find(function (el) {
      var available = el.getAttribute('data-variant-available');
      return available === 'true' || available === 'True' || available === '1';
    });
    return available ? available.getAttribute('data-variant-id') : spans[0].getAttribute('data-variant-id');
  }

  function getMatchingGiftVariantIds(configEl, mainVariantTitle) {
    var productEls = Array.prototype.slice.call(configEl.querySelectorAll(PRODUCT_SELECTOR));
    if (!productEls.length) {
      var single = getMatchingGiftVariantId(configEl, mainVariantTitle);
      return single ? [single] : [];
    }

    var ids = [];
    productEls.forEach(function (productEl) {
      var id = getMatchingGiftVariantId(productEl, mainVariantTitle);
      if (id) ids.push(id);
    });

    return ids.filter(function (id, idx) {
      return ids.indexOf(id) === idx;
    });
  }

  function getGiftAddItems(configEl, mainVariantTitle, firstFreeGiftAttribute, secondFreeGiftAttribute, parentLineKey) {
    var productEls = Array.prototype.slice.call(configEl.querySelectorAll(PRODUCT_SELECTOR));

    if (!productEls.length) {
      var singleId = getMatchingGiftVariantId(configEl, mainVariantTitle);
      if (!singleId) return [];
      var props = {};
      props[FREE_GIFT_FLAG] = 'Yes';
      props[TIMESTAMP_PROP] = new Date().toISOString();
      if (parentLineKey) props[PARENT_LINE_KEY_PROP] = parentLineKey;
      if (firstFreeGiftAttribute) props[firstFreeGiftAttribute] = 'Yes';
      return [{ id: Number(singleId), quantity: 1, properties: props }];
    }

    var items = [];
    productEls.forEach(function (productEl, idx) {
      var id = getMatchingGiftVariantId(productEl, mainVariantTitle);
      if (!id) return;

      var props = {};
      props[FREE_GIFT_FLAG] = 'Yes';
      props[TIMESTAMP_PROP] = new Date().toISOString();
      if (parentLineKey) props[PARENT_LINE_KEY_PROP] = parentLineKey;

      if (idx === 0 && firstFreeGiftAttribute) props[firstFreeGiftAttribute] = 'Yes';
      if (idx === 1 && secondFreeGiftAttribute) props[secondFreeGiftAttribute] = 'Yes';

      items.push({ id: Number(id), quantity: 1, properties: props });
    });

    return items;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to load cart.json');
      return res.json();
    });
  }

  function addGiftItems(giftItems) {
    var items = (giftItems || []).filter(Boolean);
    if (!items.length) return Promise.resolve(null);

    var payload = { items: items };

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () {}).then(function () {
          throw new Error('Failed to add free gift');
        });
      }
      return res.json();
    });
  }

  function updateMainItem(lineKey, quantity, existingProps, timestamp) {
    var props = existingProps ? JSON.parse(JSON.stringify(existingProps)) : {};
    props[HAS_FREE_GIFT_FLAG] = 'Yes';
    props[TIMESTAMP_PROP] = timestamp;

    var payload = {
      id: lineKey,
      quantity: quantity,
      properties: props
    };

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () {}).then(function () {
          throw new Error('Failed to update main item with free gift props');
        });
      }
      return res.json();
    });
  }

  function removeLineItem(lineKey) {
    if (!lineKey) return Promise.resolve(null);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to remove line item');
      return res.json();
    });
  }

  function reconcileFreeGifts() {
    if (!acquireRunLock()) return;

    var configEls = getConfigElements();
    if (!configEls.length) {
      releaseRunLock();
      return;
    }

    fetchCart()
      .then(function (cart) {
        var items = cart && cart.items ? cart.items : [];
        var hadChanges = false;
        var chain = Promise.resolve();

        configEls.forEach(function (el) {
          chain = chain.then(function () {
            var lineKey = el.getAttribute('data-line-key');
            var mainTitle = el.getAttribute('data-main-variant-title') || '';
            var hasFreeGiftAttr = (el.getAttribute('data-has-free-gift') || '').toLowerCase();

            if (!lineKey) return;

            var mainItem = items.find(function (ci) {
              return ci.key === lineKey;
            });
            if (!mainItem) return;

            var props = mainItem.properties || {};

            // If the main line already indicates gifts were handled elsewhere, don't duplicate.
            if (props[HAS_FREE_GIFT_FLAG] === 'Yes' || hasFreeGiftAttr === 'yes' || hasFreeGiftAttr === 'true') {
              return;
            }

            var firstFreeGiftAttribute = (el.getAttribute('data-first-free-gift-attribute') || '').trim();
            var secondFreeGiftAttribute = (el.getAttribute('data-second-free-gift-attribute') || '').trim();

            var giftVariantIds = getMatchingGiftVariantIds(el, mainTitle);
            if (!giftVariantIds.length) return;

            // Determine which eligible gifts are missing for this main line
            var existingGiftItemsForLine = items
              .filter(function (ci) {
                var p = ci.properties || {};
                return p[FREE_GIFT_FLAG] === 'Yes' && p[PARENT_LINE_KEY_PROP] === lineKey;
              });

            var existingGiftVariantIdSet = new Set(
              existingGiftItemsForLine.map(function (ci) { return String(ci.variant_id); })
            );

            // Backwards compatible: gifts created by older logic (linked by timestamp only)
            if (props[TIMESTAMP_PROP]) {
              var ts = props[TIMESTAMP_PROP];
              items.forEach(function (ci) {
                var p = ci.properties || {};
                if (p[FREE_GIFT_FLAG] === 'Yes' && p[TIMESTAMP_PROP] === ts) {
                  existingGiftVariantIdSet.add(String(ci.variant_id));
                }
              });
            }

            var missingGiftVariantIds = giftVariantIds.filter(function (id) {
              return !existingGiftVariantIdSet.has(String(id));
            });

            // If variant changed, remove old gifts that no longer match desired variants
            var desiredSet = new Set(giftVariantIds.map(String));
            var extraGiftLineKeys = existingGiftItemsForLine
              .filter(function (ci) { return !desiredSet.has(String(ci.variant_id)); })
              .map(function (ci) { return ci.key; });

            if (!missingGiftVariantIds.length && !extraGiftLineKeys.length) {
              // Main line might have flag missing; add it without changing quantities
              if ((props[HAS_FREE_GIFT_FLAG] !== 'Yes') && (hasFreeGiftAttr !== 'yes') && (hasFreeGiftAttr !== 'true')) {
                hadChanges = true;
                return updateMainItem(lineKey, mainItem.quantity || 1, props, props[TIMESTAMP_PROP] || new Date().toISOString()).catch(function () {});
              }
              return;
            }

            hadChanges = true;

            var timestampForMain = props[TIMESTAMP_PROP] || new Date().toISOString();
            var removeChain = Promise.resolve();
            extraGiftLineKeys.forEach(function (giftLineKey) {
              removeChain = removeChain.then(function () {
                return removeLineItem(giftLineKey);
              }).catch(function () {});
            });

            return removeChain
              .then(function () {
                if (!missingGiftVariantIds.length) return null;
                var itemsToAdd = getGiftAddItems(el, mainTitle, firstFreeGiftAttribute, secondFreeGiftAttribute, lineKey)
                  .filter(function (gi) { return missingGiftVariantIds.indexOf(String(gi.id)) > -1; });
                return addGiftItems(itemsToAdd);
              })
              .then(function () {
                // Ensure main item has the "has free gift" flag set (timestamp retained for backwards compatibility)
                return updateMainItem(lineKey, mainItem.quantity || 1, props, timestampForMain);
              })
              .catch(function () {});
          });
        });

        chain.then(function () {
          if (hadChanges) {
            window.location.reload();
            return;
          }
          releaseRunLock();
        });
      })
      .catch(function () {
        // silently fail – cart still works
        releaseRunLock();
      });
  }

  onReady(reconcileFreeGifts);
})(); 